import { render, staticRenderFns } from "./WidgetDashboardSetting.vue?vue&type=template&id=207db7f8&"
import script from "./WidgetDashboardSetting.vue?vue&type=script&lang=ts&"
export * from "./WidgetDashboardSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('207db7f8')) {
      api.createRecord('207db7f8', component.options)
    } else {
      api.reload('207db7f8', component.options)
    }
    module.hot.accept("./WidgetDashboardSetting.vue?vue&type=template&id=207db7f8&", function () {
      api.rerender('207db7f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widget-dashboard/WidgetDashboardSetting.vue"
export default component.exports